import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Handles the return leg of Emergent Google sign-in: exchanges #session_id for the app JWT.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    window.history.replaceState(null, '', location.pathname);

    if (!sessionId) { navigate('/login', { replace: true }); return; }

    axios.post(`${API_URL}/auth/google/session`, { session_id: sessionId })
      .then(res => {
        if (res.data.pending_approval) {
          navigate('/login', { replace: true, state: { pendingApproval: res.data.user } });
          return;
        }
        loginWithToken(res.data.token, res.data.user);
        toast.success(`Welcome back, ${res.data.user.name}!`);
        navigate('/select-department', { replace: true, state: { user: res.data.user } });
      })
      .catch(err => {
        toast.error(err.response?.data?.detail || 'Google sign-in failed. Please try again.', { duration: 8000 });
        navigate('/login', { replace: true });
      });
  }, [location, navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-slate-500 text-sm">
        <span className="w-4 h-4 rounded-full border-2 border-orange-500 border-t-transparent animate-spin" />
        Signing you in…
      </div>
    </div>
  );
}
